import React, { useEffect, useState, useCallback } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { instance } from "../../utils/utils";
import ComponentCompany from "./component-company";
import UserAdmin from "./user-admin";
import AdministrationRoles from "./roles-administration";
import TermsModal from "../terms-modal/termsModal";
import PreRegisteredUsersListModal from "./pre-registered-users-list-modal";
import Topbar from "../top-bar/top-bar";
import { useNavigate } from "react-router-dom";
import WelcomeModal from "../memberships/modals/welcome-modal";
import PlansModal from "../memberships/modals/plans-modal";
import ActivateTrialModal from "../memberships/modals/activate-trial-modal";
import TrialSuccessModal from "../memberships/modals/trial-success-modal";
import AddPaymentMethodModal from "../memberships/modals/add-payment-method-modal";
import { MODAL_CONFIGS } from "../memberships/modals/modal-configs";
import InlineModal from "../info-modal/infoModal";
import { getBackendError } from "../../utils/error-helpers";

const Admin = (props) => {
  const navigate = useNavigate();
  const [detailCompany, setDetailCompany] = useState(null);
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showOnboardingModal, setShowOnboardingModal] = useState(false);
  const [showPreRegisteredUsersList, setShowPreRegisteredUsersList] = useState(false);
  const [billingSummary, setBillingSummary] = useState(null);
  const [isLoadingSummary, setIsLoadingSummary] = useState(true);
  const [showAddPaymentMethodModal, setShowAddPaymentMethodModal] = useState(false);

  const [onboardingStep, setOnboardingStep] = useState(null);
  const [isTrial, setIsTrial] = useState(null);
  const [selectedPlanForTrial, setSelectedPlanForTrial] = useState(null);

  const modalSteps = ["welcome", "plans", "activateTrial", "trialSuccess"];

  const [activeModal, setActiveModal] = useState(null);
  const closeModal = () => setActiveModal(null);
  const [modalContext, setModalContext] = useState({
    summary: null
  });
  const [infoModal, setInfoModal] = useState(null);

  const [sourceOriginAddPaymentMethodModal, setSourceOriginAddPaymentMethodModal] = useState(null);

  function getCompanyDetail() {
    setLoading(true);
    instance
      .get(`memberships/corp/company`)
      .then((res) => res.data)
      .then((data) => {
        setDetailCompany(data);

        setLoading(false);
      })
      .catch((err) => console.error(err));
  }

  function showMembersPreRegister() {
    let styleModal = {
      display: "flex",
      position: "fixed",
      zIndex: 999,
      whiteSpace: "pre-line",
    };

    instance
      .get(`memberships/corp/company/members/preregisters`)
      .then((res) => res.data)
      .then((data) => {
        setModal(
          <div
            className="popUpServices justify-content-center align-items-center"
            style={styleModal}
          >
            <div
              className="modalInfoContenido"
              style={{
                background: "white",
                borderRadius: "20px",
                boxShadow: "0px 5px 5px 4px rgba(157,172,189,0.7)",
                padding: "4% 10%",
              }}
            >
              <div
                className=""
                style={{
                  position: "absolute",
                  top: "5%",
                  right: "5%",
                  fontWeight: "bold",
                  fontSize: "1.5rem",
                  color: " #9DACBD",
                  cursor: "pointer",
                }}
                onClick={() => setModal(null)}
              >
                <i className="bi bi-x-circle"></i>
              </div>
              <div
                className=" mb-3 py-3"
                style={{
                  lineHeight: "100%",
                  textAlign: "center",

                  color: "var(--elevvabutonLogin_User)",
                }}
              >
                <strong>Pendientes por crear:</strong>
              </div>
              {data.length > 0 ? (
                <PerfectScrollbar
                  className="px-3"
                  style={{ maxHeight: "15rem" }}
                >
                  <div className="table-container">
                    <table className="custom-table">
                      <thead>
                        <tr>
                          <th>Correo electrónico</th>
                          <th>Membresía</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((row, index) => (
                          <tr key={index}>
                            <td>{row.email}</td>
                            <td>{row.membership}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </PerfectScrollbar>
              ) : (
                "No existen usuarios"
              )}
            </div>
          </div>
        );
      })
      .catch((err) => console.error(err));
  }

  const getBillingSummary = () => {
    setIsLoadingSummary(true);
    instance
      .get(
        `customers/company/plan/billing-summary`
      )
      .then((res) => res.data)
      .then((data) => {
        setBillingSummary(data);
      })
      .catch((err) => {
        console.error(err);
        setIsLoadingSummary(null);
      })
      .finally(() => {
        setIsLoadingSummary(false);
      });
  }

  const goNextStep = () => {
    setOnboardingStep(prev => {
      if (typeof prev === "number") {
        const next = prev + 1;
        return next < modalSteps.length ? next : null;
      }
      return null;
    });
  };

  const goBackStep = () => {
    setOnboardingStep(prev => {
      if (typeof prev === "number") {
        const back = prev - 1;
        return back >= 0 ? back : prev;
      }
      return prev;
    });
  };

  const money = (value) => {
    if (value == null) return "COP $0";
    const n = Number(value);
    if (Number.isNaN(n)) return "COP $0";
    return `COP $${n.toLocaleString("es-CO")}`;
  };

  const renderOnboardingModals = () => {
    if (onboardingStep === null || detailCompany?.bypass_card) return null;

    if (onboardingStep === 0) {
      return (
        <WelcomeModal
          show={true}
          onStartTrial={async () => {
            setIsTrial(true);
            goNextStep();
          }}
          onSkipTrial={async () => {
            setIsTrial(false);
            goNextStep();
          }}
        />
      );
    }

    if (onboardingStep === 1) {
      return (
        <PlansModal
          show
          onPlanSelected={(planPayload) => {
            setSelectedPlanForTrial(planPayload);
            goNextStep();
          }}
          onBack={goBackStep}
        />
      );
    }


    if (onboardingStep === 2) {
      if (!selectedPlanForTrial) return null; // Avoid crash if plan is not selected

      return (
        <ActivateTrialModal
          show
          isTrial={isTrial}
          selectedPlan={selectedPlanForTrial}
          onCompleted={goNextStep}
          onBack={goBackStep}
          onCancel={() => setOnboardingStep(null)}
        />
      );
    }


    if (onboardingStep === 3) {
      return (
        <TrialSuccessModal
          show={true}
          selectedPlan={selectedPlanForTrial?.frontendPlan?.name}
          isTrial={isTrial}
          onClose={() => {
            setOnboardingStep(null);
            getCompanyDetail();
            getBillingSummary();
          }}
        />
      );
    }

    return null;
  };

  const handleSkipTrial = async () => {
    setLoading(true);
    try {
      const res = await instance.post("/customers/company/plan/skip-trial");
      setModalContext({
        summary: {
          planName: billingSummary?.plan?.name,
          transactionId: res?.data?.order_number,
          totalPaid: res?.data?.final_cost
        }
      });
      setActiveModal("SUCCESS");
    } catch (error) {

      const backendError = error?.response?.data;

      if (backendError?.error_payment) {
        setModalContext({
          summary: {}
        });
        setActiveModal("PAYMENT_REJECTED");
        return;
      }
      const errorMessage = getBackendError(error);
      setInfoModal({
        iconType: "infoError",
        title: "Error al saltar la prueba gratuita",
        description: errorMessage,
        secondaryAction: { label: "Cerrar", onClick: () => setInfoModal(null) },
      });
    } finally {
      setLoading(false);
    }
  };

  const remindTomorrow = () => {
    const tomorrow = Date.now() + 24 * 60 * 60 * 1000;

    localStorage.setItem(
      "trial_expiring_remind_at",
      String(tomorrow)
    );

    setActiveModal(null);
  };

  const canShowTrialReminder = () => {
    const remindAt = localStorage.getItem("trial_expiring_remind_at");
    if (!remindAt) return true;

    return Date.now() > Number(remindAt);
  };

  const remindUserLimitTomorrow = () => {
    const tomorrow = Date.now() + 24 * 60 * 60 * 1000;

    localStorage.setItem(
      "user_limit_remind_at",
      String(tomorrow)
    );

    setActiveModal(null);
  };

  const canShowUserLimitReminder = () => {
    const remindAt = localStorage.getItem("user_limit_remind_at");
    if (!remindAt) return true;

    return Date.now() > Number(remindAt);
  };

  const handlePlanReactivation = async () => {
    setLoading(true);
    try {
      const res = await instance.post("customers/company/plan/reactive");
      setModalContext({
        summary: {
          planName: billingSummary?.plan?.name,
          transactionId: res?.data?.order_number,
          totalPaid: res?.data?.amount
        }
      });
      setActiveModal("SUCCESS");
    } catch (error) {

      const backendError = error?.response?.data;

      if (backendError?.error_payment) {
        setModalContext({
          summary: {}
        });
        setActiveModal("PAYMENT_REJECTED");
        return;
      }
      const errorMessage = getBackendError(error);
      setInfoModal({
        iconType: "infoError",
        title: "Error al reactivar el plan",
        description: errorMessage,
        secondaryAction: { label: "Cerrar", onClick: () => setInfoModal(null) },
      });
    } finally {
      setLoading(false);
    }
  };

  const resolveSubscriptionModal = ({
    billingSummaryData,
    planDetailData,
    companyDetailData
  }) => {
    if (companyDetailData?.bypass_card) return null;
    if (!companyDetailData?.has_active_plan && companyDetailData?.has_deactive_plan) {
      return {
        modal: "SUBSCRIPTION_SUSPENDED",
        context: {
          planName: billingSummaryData?.plan?.name || planDetailData?.plan_title,
          totalWithDiscount: money(planDetailData?.total_with_discount)
        }
      };
    }

    if (!billingSummaryData?.plan) return null;
    const plan = billingSummaryData.plan;

    const isTrial = plan.is_trial;
    const trialDaysLeft = plan.trial_days_remaining;

    if (isTrial) {
      if (trialDaysLeft > 0 && trialDaysLeft <= 3 && canShowTrialReminder()) {
        return {
          modal: "TRIAL_EXPIRING_WARNING",
          context: {
            daysLeft: trialDaysLeft,
            userName: companyDetailData?.name,
            totalWithDiscount: money(planDetailData?.total_with_discount)
          }
        };
      }
    }

    if (
      planDetailData?.client_slots_used >= planDetailData?.contracted_client_slots &&
      canShowUserLimitReminder()
    ) {
      return {
        modal: "USER_LIMIT_REACHED",
        context: {
          planName: plan.name
        }
      };
    }

    return null;
  };

  const handleOpenAddPaymentMethodModal = () => {
    setSourceOriginAddPaymentMethodModal("admin");
    closeModal();
    setShowAddPaymentMethodModal(true);
  };


  const fetchData = useCallback(async (isMounted = { current: true }) => {
    setIsLoadingSummary(true);
    setLoading(true);

    if (!isMounted.current) return;

    // Fetch data independently so one failure doesn't break everything
    let billingSummaryData = null;
    let planDetailData = null;
    let companyDetailData = null;

    try {
      const billingRes = await instance.get("customers/company/plan/billing-summary").catch(() => null);
      billingSummaryData = billingRes?.data;
    } catch (e) {
      console.error("Error fetching billing summary", e);
    }

    try {
      const planRes = await instance.get("/customers/company/plan/detail").catch(() => null);
      planDetailData = planRes?.data;
    } catch (e) {
      console.error("Error fetching plan detail", e);
    }

    try {
      const companyRes = await instance.get("memberships/corp/company");
      companyDetailData = companyRes.data;
    } catch (e) {
      console.error("Error fetching company detail", e);
    }

    if (!isMounted.current) return;

    setBillingSummary(billingSummaryData);
    setDetailCompany(companyDetailData);

    try {
      const modalResult = resolveSubscriptionModal({
        billingSummaryData,
        planDetailData,
        companyDetailData
      });

      if (modalResult) {
        setModalContext({ summary: modalResult.context });
        setActiveModal(modalResult.modal);
      }
    } catch (error) {
      console.error("Error resolving subscription modal:", error);
    }

    if (isMounted.current) {
      setIsLoadingSummary(false);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const isMounted = { current: true };
    fetchData(isMounted);

    return () => {
      isMounted.current = false;
    };
  }, [fetchData]);

  useEffect(() => {
    const checkTermsAndRedirect = async () => {
      const termsAccepted =
        localStorage.terms_and_conditions_accepted === "true";
      const privacyAccepted = localStorage.privacy_policy_accepted === "true";
      const role = parseInt(localStorage.elevva_role);
      const validRole = [10, 20, 30].includes(role);
      try {
        const companyData = await instance
          .get("memberships/corp/company")
          .then((res) => res.data);

        if (companyData?.is_force_onboarding || companyData?.is_force_onboarding_membership || companyData?.is_force_onboarding_data) {
          setShowOnboardingModal(true);
        } else {
          setDetailCompany(companyData);
          if (!termsAccepted && !privacyAccepted && validRole) {
            setShowTermsModal(true);
            return;
          }
        }
      } catch (err) {
        console.error(err);
      }
    };

    checkTermsAndRedirect();
  }, []);

  useEffect(() => {
    if (!detailCompany || detailCompany?.bypass_card) return;

    const {
      old_company,
      has_default_active_credit_card,
      has_any_active_credit_card,
      has_active_plan,
      has_deactive_plan,
    } = detailCompany;

    if (has_deactive_plan) {
      setOnboardingStep(null);
      return;
    }

    const hasCreditCard = has_default_active_credit_card && has_any_active_credit_card;

    // 1. Completed subscription
    if (has_active_plan && hasCreditCard) {
      setOnboardingStep(null);
      return;
    }

    // 2. Has plan or is legacy but missing cards -> Needs to update payment method
    if ((has_active_plan || old_company) && !hasCreditCard) {
      setModalContext({
        summary: null,
        canClose: has_active_plan
      });
      setActiveModal("UPDATE_ALERT");
      return;
    }

    // 3. New company without plan -> Start from Welcome
    if (!old_company && !has_active_plan) {
      setOnboardingStep(0);
      return;
    }

    // 4. Fallback for legacy company without plan but with card
    if (old_company && !has_active_plan) {
      setOnboardingStep(2);
      return;
    }

    setOnboardingStep(null);
  }, [detailCompany]);

  const planCardStatusClass =
    billingSummary === undefined
      ? ""
      : billingSummary?.plan?.title
        ? ""
        : "top-card-expired";

  return (
    <>
      <div className="admin-container flex-grow-1 d-flex flex-column">
        {modal}
        <Topbar />
        <div className="admin-content-wrapper d-flex py-2 px-3">
          <div className="container-company-info">
            <ComponentCompany />
          </div>
          <div className="container-company-users d-flex flex-column gap-3">

            {isLoadingSummary ?
              (
                <div className="top-cards-row d-flex gap-3 w-100">
                  <div className="top-card">
                    <div className="spinner-border text-secondary" role="status">
                      <span className="visually-hidden">Cargando...</span>
                    </div>
                  </div>
                  <div className="top-card">
                    <div className="spinner-border text-secondary" role="status">
                      <span className="visually-hidden">Cargando...</span>
                    </div>
                  </div>
                  <div className="top-card">
                    <div className="spinner-border text-secondary" role="status">
                      <span className="visually-hidden">Cargando...</span>
                    </div>
                  </div>
                </div>
              )
              : (
                <div className="top-cards-row d-flex gap-3 w-100">
                  <div className="top-card d-flex flex-column gap-2 p-3">
                    <div className="d-flex flex-column justify-content-start align-items-start w-100">
                      <span className="top-card-title d-flex align-items-center gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none">
                          <rect x="3" y="6" width="18" height="13" rx="2" stroke="#9DACBD" stroke-width="2" />
                          <path d="M7 15H7.01" stroke="#9DACBD" stroke-width="2" stroke-linecap="round" />
                          <path d="M4 11H21" stroke="#9DACBD" stroke-width="2" stroke-linecap="round" />
                        </svg>
                        FACTURACIÓN
                      </span>
                      <span className="top-card-subtitle">
                        {detailCompany?.bypass_card ? "Cuenta Activa" : (billingSummary?.payment_method?.franchise || "N/A") + " .. " + (billingSummary?.payment_method?.last_four_digits || "----")}
                      </span>
                      <span className="top-card-expiration">
                        {detailCompany?.bypass_card ? "Sin cargos pendientes" : `Próximo cobro: ${billingSummary?.payment_method?.renewal_date || "N/A"}`}
                      </span>
                    </div>

                    <div className="d-flex flex-row gap-2 align-items-center justify-content-end w-100">
                      <button
                        className="top-card-button align-self-end"
                        onClick={() => setShowAddPaymentMethodModal(true)}
                        disabled={detailCompany?.bypass_card}
                        style={detailCompany?.bypass_card ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                      >
                        Método de pago
                      </button>
                      <button
                        className="top-card-button-outline align-self-end"
                        onClick={() => navigate("/admin/billing-history")}
                      >
                        Facturación
                      </button>
                    </div>
                  </div>

                  <div className={`top-card d-flex flex-column gap-2 p-3 ${planCardStatusClass}`}>
                    <div className="d-flex flex-column justify-content-start align-items-start w-100">
                      <span className="top-card-title d-flex align-items-center gap-1">
                        {detailCompany?.bypass_card ? (
                          "ESTADO DE CUENTA"
                        ) : billingSummary?.plan?.title ? (
                          "PLAN ACTUAL" +
                          (billingSummary.plan.is_trial
                            ? ` (${billingSummary.plan.name})`
                            : "")
                        ) : detailCompany?.old_company ? (
                          "ESTADO DE PLAN"
                        ) : (
                          <>
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                              <circle cx="6" cy="6" r="4.5" transform="rotate(-180 6 6)" stroke="white" />
                              <path d="M5.75 8.25C5.75 8.11193 5.86193 8 6 8C6.13807 8 6.25 8.11193 6.25 8.25C6.25 8.38807 6.13807 8.5 6 8.5C5.86193 8.5 5.75 8.38807 5.75 8.25Z" fill="white" stroke="white" stroke-width="0.5" />
                              <path d="M6 3.5L6 7" stroke="white" />
                            </svg>
                            PLAN VENCIDO
                          </>
                        )}
                      </span>
                      <span className="top-card-subtitle">
                        {detailCompany?.bypass_card ? "Acceso Elevva" : (billingSummary?.plan?.title || (detailCompany?.old_company ? "Pendiente" : "ELEVVA PRO"))}
                      </span>
                      <span className="top-card-expiration">
                        {detailCompany?.bypass_card ? "Vigencia Permanente" : (billingSummary?.plan?.renewal_date || (detailCompany?.old_company ? "Contacte soporte" : "Renueva para recuperar acceso"))}
                      </span>
                    </div>
                    <button
                      className={`top-card-button align-self-end ${planCardStatusClass}`}
                      onClick={() => navigate("/admin/edit-member")}
                      disabled={detailCompany?.bypass_card || (!billingSummary?.plan?.title && detailCompany?.old_company)}
                      style={(detailCompany?.bypass_card || (!billingSummary?.plan?.title && detailCompany?.old_company)) ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                    >
                      {detailCompany?.bypass_card ? "Plan Especial" : (billingSummary?.plan?.title ? "Gestionar Plan" : (detailCompany?.old_company ? "Ver detalles" : "Reactivar Plan"))}
                    </button>
                  </div>

                  <div className="top-card top-card-roles d-flex py-3">
                    <AdministrationRoles />
                  </div>
                </div>
              )
            }

            <div className="users-list-wrapper">
              <UserAdmin
                showMembersPreRegister={showMembersPreRegister}
                setShowPreRegisteredUsersList={setShowPreRegisteredUsersList}
              />
            </div>
          </div>
        </div>
      </div>

      {showTermsModal && <TermsModal onClose={() => setShowTermsModal(false)} />}

      {showOnboardingModal && (
        <InlineModal
          title="Completa tu información"
          description="Hay algunos datos importantes que aún no has completado o actualizado. Esto es necesario para brindarte una mejor experiencia en la plataforma."
          primaryAction={{
            label: "Completar ahora",
            onClick: () => {
              setShowOnboardingModal(false);
              let redirectUrl = "selectMembership/Usuario?fromAdmin=true";
              if (detailCompany?.is_force_onboarding_membership) {
                redirectUrl += "&force_membership=true";
              }
              if (detailCompany?.is_force_onboarding_data) {
                redirectUrl += "&force_data=true";
              }
              window.location.href = redirectUrl;
            },
          }}
        />
      )}

      {showPreRegisteredUsersList && (
        <PreRegisteredUsersListModal
          show
          onHide={() => setShowPreRegisteredUsersList(false)}
        />
      )}

      <AddPaymentMethodModal
        show={showAddPaymentMethodModal}
        onHide={() => setShowAddPaymentMethodModal(false)}
        sourceOrigin={sourceOriginAddPaymentMethodModal}
        onSuccess={() => fetchData({ current: true })}
      />

      {renderOnboardingModals()}

      {activeModal && (
        <InlineModal
          {...MODAL_CONFIGS[activeModal]({
            navigate: (path) => {
              if (activeModal === "SUCCESS" && path === "/admin/") {
                window.location.reload();
              } else {
                navigate(path);
              }
            },
            closeModal: activeModal === "USER_LIMIT_REACHED" ? remindUserLimitTomorrow : closeModal,
            handleSkipTrial,
            remindTomorrow,
            handlePlanReactivation,
            handleOpenAddPaymentMethodModal,
            ...modalContext
          })}
        />
      )}

      {infoModal && (
        <InlineModal
          show={true}
          onClose={() => setInfoModal(null)}
          title={infoModal?.title}
          description={infoModal?.description}
          iconType={infoModal?.iconType}
          primaryAction={infoModal?.primaryAction}
          secondaryAction={infoModal?.secondaryAction}
        />
      )}
    </>
  );
};

export default Admin;